if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			// Optional
			loadProductFirst: true,
			styleScrollToTop: 'style2',
			numberFilterTree: 2,
			showPlaceholderProductList: true,
			placeholderProductPerRow: 3,
		},
		selector: {
			breadcrumb: '.breadcrumb-nav',
			otpTopCartLink: 'a[href="/cart"].site-header__cart'
		}
	};
}

(function () {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function (data, index, totalProduct) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		if (!totalProduct) totalProduct = this.totalProduct;

		/*** Prepare data ***/
		var images = data.images_info;
        console.log(data);
		// Displaying price base on the policy of Shopify, have to multiple by 100
        var description  = data.description; // 追加
        var metafields  = data.metafields;// 追加
        console.log(metafields);

for (var key in metafields) {
  if ( metafields[key].key == '_ask_disp') {
    var askDisp = metafields[key].value;
  }
  if ( metafields[key].key == '_price_hide') {
    var priceHide = metafields[key].value;
  }
  console.log(metafields[key].value +"です");
}
      
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add onSale label
		var itemSaleLabelHtml = onSale ? boostPFSTemplate.saleLabelHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

		// Add a specific class for grid item
		var gridItemWidthClass = 'medium-up--one-third small--one-half';
		if (totalProduct == 1) {
			gridItemWidthClass = 'medium-up--one-third small--one-whole';
		}
		itemHtml = itemHtml.replace(/{{gridItemWidthClass}}/g, gridItemWidthClass);

		// Add Thumbnail
		var itemImagesHtml = '';
		if (images.length > 0) {
			var aspect_ratio = images[0]['width'] / images[0]['height'];
			//itemImagesHtml += '<div class="supports-js" style="max-width: ' + Math.round(600 * aspect_ratio) + 'px; margin: 0 auto;">';
			itemImagesHtml += '<a href="{{itemUrl}}" class="product__image-wrapper" style="padding-top:' + (1 / aspect_ratio * 100) + '%;" title="{{itemTitle}}">';
			itemImagesHtml += '<img class="product__image lazyload"' +
				' src="' + Utils.getFeaturedImage(images, '150x150') + '"' +
				' data-src="' + Utils.getFeaturedImage(images, '1x1').replace('_1x1.', '_{width}x.') + '"' +
				' data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
				' data-aspectratio="' + aspect_ratio + '"' +
				' data-sizes="auto"' +
				' alt="{{itemTitle}}"' +
				' style="max-width: ' + Math.round(600 * aspect_ratio) + 'px; max-height: 600px;">';
			itemImagesHtml += '</a>';
			//itemImagesHtml += '</div>';
		} else {
			itemImagesHtml += '<figure><a href="{{itemUrl}}" class=" supports-js product__image-wrapper" title="{{itemTitle}}">' +
				'<img src="' + boostPFSAppConfig.general.no_image_url + '" alt="{{itemTitle}}"></figure>' +
				'</a>';
		}
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Sale
        /*if (onSale) {
          	var itemSaleHtml = '<h5 class="badge badge-sale"><span>' + boostPFSConfig.label.sale + '</span></h5>';
          	itemHtml = itemHtml.replace(/{{itemSaleHtml}}/g, itemSaleHtml);
        }*/
      
      // Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);
        

		// Add Price
		var itemPriceHtml = '';
      //askDisp/の条件分岐追加
      if (priceHide != 'true') {
        if (askDisp == 'true') {
          itemPriceHtml += 'ASK';
        } else {
          if (onSale) {
              itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
              itemPriceHtml += ' <s>' + Utils.formatMoney(data.compare_at_price_min, Globals.moneyFormat) + '</s>';
              if (priceVaries) {
                  itemPriceHtml += (boostPFSConfig.label.sale_from_price).replace(/{{ price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
              } else {
                  itemPriceHtml += '<strong class="visually-hidden">' + boostPFSConfig.label.sale_price + '</strong>';
                  itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
              }
          } else {
              itemPriceHtml += '<span class="product-price">';
              if (priceVaries) {
                  itemPriceHtml += (boostPFSConfig.label.from_price).replace(/{{ price }}/g, Utils.formatMoney(data.price_min, Globals.moneyFormat));
              } else {
                  itemPriceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.regular_price + '</span>';
                  itemPriceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
              }
          }
          itemPriceHtml += '</span>';
          if(soldOut) {
              itemPriceHtml += ' <strong class="sold-out-text">' + boostPFSConfig.label.sold_out + '</strong>'
          }
          }
      	} else {
        	 itemPriceHtml += '';
      	}
      
      	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      
      
      	// 追加
        var itemDescriptionHtml = '';
        console.log(description);
        if (description) {
			itemDescriptionHtml = '<p>{{itemDescription}}</p>';
        }
      
        itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescriptionHtml);
     
		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
        itemHtml = itemHtml.replace(/{{itemDescription}}/g, data.description);// 追加
        itemHtml = itemHtml.replace(/{{askDisp}}/g, askDisp);// 追加
        itemHtml = itemHtml.replace(/{{priceHide}}/g, priceHide);// 追加
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousHtml : '';
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextHtml : '';
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);

			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}

			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
				html = html.replace(/{{itemLabelActive}}/g, sortingArr[Globals.queryParams.sort]);

			}
		}
		return html;
	};

	// Build Breadcrumb
	Breadcrumb.prototype.compileTemplate = function (colData) {
		if (!colData) colData = this.collectionData;
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
			var breadcrumbHtml = boostPFSTemplate.breadcrumbHtml;
			var colInfo = colData.collection;
			var currentCollectionHtml = '';
			// If has tag
			if (Array.isArray(boostPFSConfig.general.current_tags) && boostPFSConfig.general.current_tags.length > 0) {
				currentCollectionHtml += '<span itemscope itemtype="http://data-vocabulary.org/Breadcrumb">';
				currentCollectionHtml += '<a href="{{ collection_url }}" itemprop="url">' +
					'<span itemprop="title">' + colInfo.title + '</span>' +
					'</a>';
				currentCollectionHtml += '<span class="breadcrumb-nav__separator" aria-hidden="true">›</span>';
				currentCollectionHtml += '</span>';
				// Get First tag
				var current_tags = boostPFSConfig.general.current_tags;
				currentCollectionHtml += current_tags[0];
			} else {
				currentCollectionHtml = colInfo.title;
			}
			breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollection}}/g, currentCollectionHtml);
			html = breadcrumbHtml;
		}
		return html;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;
	};

	// Build additional elements after everything is rendered
	FilterResult.prototype.afterRender = function (data) {
		if (!data) data = this.data;
	};
})();